import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.template');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-template',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.template/view.scss */
/* src/app/page.admin.template/view.scss: no such file or directory */`],
})
export class PageAdminTemplateComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public list: any = [];
    public categories: string[] = [];
    public selectedCategory: string = "";
    public tab: string = "active";

    public keyuptime: any = 0;

    public search: any = {
        text: "",
        page: 1,
        dump: 40
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role("admin", "/");
        await this.loadCategories();
        await this.load();
    }

    public async switchTab(tab: string) {
        this.tab = tab;
        this.selectedCategory = "";
        this.search.text = "";
        await this.loadCategories();
        await this.load();
    }

    public async loadCategories() {
        const { code, data } = await wiz.call("categories", { archived: this.tab === 'archived' ? 'true' : 'false' });
        if (code == 200) {
            this.categories = data;
        }
    }

    public async onCategoryChange(value: string) {
        this.selectedCategory = value;
        await this.load();
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", {
            ...this.search,
            archived: this.tab === 'archived' ? 'true' : 'false',
            category: this.selectedCategory
        });

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public async searchAction() {
        let keyuptime: any = new Date().getTime();
        this.keyuptime = keyuptime;
        await this.service.render(500);
        if (this.keyuptime != keyuptime) return;
        await this.load();
    }

    public navigateToItem(item: any) {
        this.service.href(`/admin/template/${item.id}/info`);
    }
}

export default PageAdminTemplateComponent;